import { Box, Stack, Typography, CircularProgress } from '@mui/material';

import { useTranslate } from 'src/locales';
import { DashboardLayout } from 'src/layouts/dashboard';

export function PermissionLoadingScreen() {
  const { t } = useTranslate('translation');

  return (
    <DashboardLayout>
      <Box
        sx={{
          height: '90vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={48} />
          <Typography variant="h6">{t('LOADING')}</Typography>
        </Stack>
      </Box>
    </DashboardLayout>
  );
}
